import React, { useContext } from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import { useSelector } from "react-redux";
import NotFound from "components/NotFound";
import SettingsMenu from "./Settings";
import { SettingsProvider } from "./SettingsContext";
import AppContext from "AppContext";
import PrivateRoute from "components/PrivateRoute";
import Users from "./Users";
import Modules from "./Modules";
import BusinessHours from "./BusinessHours";
import Status from "./Status";
import Types from "./Types";
import ContactTypes from "./ContactTypes";
import FileLocations from "./FileLocations";
import Flows from "./Flows";
import POSCategories from "./POSCategories";
import InvoicingIssuer from "./InvoicingIssuer";
import Products from "./Products";
import Configurations from "./Configurations";
import ChainOfCustody from "./ChainOfCustody";
import GroupsPermissions from "./GroupsPermissions";
import Forms from "./Forms";
import { Tenant } from "utils/tenants";
import { hasSettingsPermission } from "utils/session";

function Settings() {
    const {
        api: { Settings },
    } = useContext(AppContext);
    const { user } = useSelector((state) => state.Login);

    const defaultPath = user.isAdmin ? "/settings/users" : "/settings/forms";

    return (
        <SettingsProvider value={Settings}>
            <SettingsMenu>
                <Switch>
                    <Redirect exact from="/settings" to={defaultPath} />
                    {user.isAdmin && <PrivateRoute path="/settings/users" component={Users} />}
                    {user.isAdmin && <PrivateRoute path="/settings/groups-permissions" component={GroupsPermissions} />}
                    {user.isAdmin && <PrivateRoute exact path="/settings/business-hours" component={BusinessHours} />}
                    {user.isAdmin && Tenant.getFeatures().modules.enabled && (
                        <PrivateRoute exact path="/settings/types" component={Types} />
                    )}
                    {user.isAdmin && Tenant.getFeatures().modules.enabled && (
                        <PrivateRoute exact path="/settings/status" component={Status} />
                    )}
                    {user.isAdmin && Tenant.getFeatures().modules.enabled && (
                        <PrivateRoute exact path="/settings/modules" component={Modules} />
                    )}
                    {user.isAdmin && Tenant.getFeatures().modules.enabled && (
                        <PrivateRoute exact path="/settings/contact-types" component={ContactTypes} />
                    )}
                    {user.isAdmin && Tenant.getFeatures().modules.enabled && (
                        <PrivateRoute exact path="/settings/file-locations" component={FileLocations} />
                    )}
                    {user.isAdmin && Tenant.getFeatures().modules.enabled && <PrivateRoute path="/settings/flows" component={Flows} />}
                    {user.isAdmin && Tenant.getFeatures().pos.enabled && (
                        <PrivateRoute exact path="/settings/pos/categories" component={POSCategories} />
                    )}
                    {user.isAdmin && Tenant.getFeatures().invoicing.enabled && (
                        <PrivateRoute exact path="/settings/documents-issuer" component={InvoicingIssuer} />
                    )}
                    {user.isAdmin && Tenant.getFeatures().invoicing.enabled && (
                        <PrivateRoute exact path="/settings/services" component={Products} />
                    )}
                    {user.isAdmin && <PrivateRoute exact path="/settings/system-parameters" component={Configurations} />}
                    {user.isAdmin && Tenant.getFeatures().chainOfCustody.enabled && (
                        <PrivateRoute path="/settings/chain-of-custody" component={ChainOfCustody} />
                    )}
                    {hasSettingsPermission(user, "settings.forms.access") && Tenant.getFeatures().forms.enabled && (
                        <PrivateRoute path="/settings/forms" component={Forms} />
                    )}
                    <Route component={NotFound} />
                </Switch>
            </SettingsMenu>
        </SettingsProvider>
    );
}

export default Settings;
